<template>
    <settings-wrapper title="Space settings" section="External storage">
        <space-external-storage :space-id="activeSpaceId" :is-space-admin-override="isSpaceAdmin" />
    </settings-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingsWrapper from '@/components/SettingsWrapper.vue'

const SpaceExternalStorage = () => import('../components/SpaceExternalStorage.vue')

export default {
    name: 'SpaceConfigurationExternalStorage',
    components: {
        SpaceExternalStorage,
        SettingsWrapper
    },
    computed: {
        ...mapGetters('spaceStore', ['isSpaceAdmin']),
        activeSpaceId() {
            return this.$route.params.sid
        }
    }
}
</script>
